import React from 'react'
import "../App.css";
import Navbar from "../components/Navbar"
import Footer from '../components/Footer';
// import history from '../history.js'
import {
  DropdownToggle, DropdownMenu, DropdownItem,
  UncontrolledDropdown,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import config from '../config'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from 'moment'
// import VideoPlayer from '../assets/video-js/video'
import VideoPlayer from '../components/Video'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import poster from '../images/default-image.png'
import '../styles/layout.css';
import './Videos.css';

library.add(fas)

const optionToast = {
	position: "top-right",
	autoClose: 5000,
	hideProgressBar: true,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true,
	progress: undefined,
}


class Video extends React.Component {
  constructor(props) {
    super(props);

		this.handleChangeEmbed = this.handleChangeEmbed.bind(this);
		this.handleChangeTitle = this.handleChangeTitle.bind(this);
		this.handleChangeDesc = this.handleChangeDesc.bind(this);
		this.handleChangeEnable = this.handleChangeEnable.bind(this);
		this.handleChangeSearch = this.handleChangeSearch.bind(this);
		this.handleChangeThumbnails = this.handleChangeThumbnails.bind(this);

		this.state = {
			video: [],
			index: 1,
			video_id: '',
			embed: '',
			desc: '',
			title: '',
			enable: '',
			modalPreview: false,
			modalEmbed: false,
			modalTranscode: false,
			modalEdit: false,
			modalDelete: false,
			modalPreviewErr: false,
			modalEditErr: false,
			stream_url: '',
			resetPaginationToggle: null,
			filterText: null,
			search: '',
			default: true,
			thumbnail: '',
			thumbnailFile: '',
			thumbnails: [],
			imgSrc: null
		}
  }

	componentDidMount = () => {
		this.feedVideo()
		// this.testImage("http://foo.com/bar.jpg");
	}

	togglePreview = (e, id, status) => {
		this.setState({
			video_id: id
		})

		if (id) {
			axios.post(config.host + '/api/v1/video/record/preview' , {
				id: id,
				userid: localStorage.StudioUserID
			}).then(res => {
				
				this.setState({
					stream_url: res.data.stream_url
				})
				console.log(this.state.stream_url);
	
				// localStorage.setItem('StudioStreamUrl', this.state.stream_url);
			}).catch(err => {
	
			})
		}

		if (!status || status === 'complete') {
			this.setState({
				modalPreview: !this.state.modalPreview
			})
		} else {
			this.setState({
				modalPreviewErr: !this.state.modalPreviewErr
		})

		
		
		}
    
  }

	togglePreviewErr = () => {
    this.setState({
      modalPreviewErr: !this.state.modalPreviewErr
    })
  }
	toggleEmbed = (e, id) => {
		// console.log(id);
		axios.post(config.host + '/api/v1/video/record/detail' , {
			id: id,
			userid: localStorage.StudioUserID
		}).then(res => {
			// console.log(res.data.result.embed_player);
			this.setState({
				embed: res.data.result.embed_player
			})
		}).catch(err => {

		})
    this.setState({
      modalEmbed: !this.state.modalEmbed
    })
  }

	toggleTranscode = () => {
    this.setState({
      modalTranscode: !this.state.modalTranscode
    })
  }

	toggleEdit = (e, id) => {
    this.setState({
      modalEdit: !this.state.modalEdit,
			video_id: id,
			imgSrc: null
    })

		axios.post(config.host + '/api/v1/video/record/detail' , {
			id: id,
			userid: localStorage.StudioUserID
		}).then(res => {
			console.log(res.data.result);
			this.setState({
				title: res.data.result.title,
				desc: res.data.result.desc,
				enable: res.data.result.enable,
				thumbnail: res.data.result.thumbnail,
				thumbnails: res.data.result.thumbnail_array
			})
		}).catch(err => {

		})
  }

	toggleDelete = (e, id) => {
    this.setState({
      modalDelete: !this.state.modalDelete,
			video_id: id
    })

		axios.post(config.host + '/api/v1/video/record/detail' , {
			id: id,
			userid: localStorage.StudioUserID
		}).then(res => {
			// console.log(res.data.result);
			this.setState({
				title: res.data.result.title
			})
		}).catch(err => {
			
		})
  }

	handleChangeEmbed(event) {
    this.setState({
      embed: event.target.value
    });
  }

	handleChangeDesc(event) {
    this.setState({
      desc: event.target.value
    });
  }

	handleChangeTitle(event) {
    this.setState({
      title: event.target.value
    });
  }

	handleChangeEnable(event) {
    this.setState({
      enable: event.target.value
    });
  }

	handleChangeSearch(event) {
		this.setState({
      search: event.target.value
    });
	}

	getInitialState(){
		return{file: []}
	}

	handleChangeThumbnails() {
		var file = this.refs.file.files[0];
  	var reader = new FileReader();
  	reader.readAsDataURL(file);

		reader.onloadend = function (e) {
      this.setState({
          imgSrc: reader.result
      })
    }.bind(this);
  	// console.log(reader) // Would see a path?
		// console.log(this.state.imgSrc);
		// console.log(this.refs.file.files);
	}

	feedVideo = () => {
		axios.post(config.host + '/api/v1/video/record' , {
			keyword: this.state.search,
			userid: localStorage.StudioUserID
		}).then(res => {
			console.log(res.data.result);
			this.setState({
				video: res.data.result
			})
		}).catch(err => {

		})
	}

	

	embedCopy = () => {
		toast.success('Copied to clipboard !', optionToast);
		var copyText = document.getElementById('embed');
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand('copy');
	}

	UpdateVideo = () => {
		this.updateThumbnail()
		// console.log(this.state.video_id, localStorage.StudioUserID, this.state.title, this.state.desc, this.state.enable);
		axios.post(config.host + '/api/v1/video/record/update' , {
			id: this.state.video_id,
			userid: localStorage.StudioUserID,
			title: this.state.title,
			desc: this.state.desc,
			enable: this.state.enable
		}).then(res => {
			toast.success('Update video successfully !', optionToast);
			this.setState({
				modalEdit: !this.state.modalEdit
			})
			this.feedVideo()
		}).catch(err => {

		})
	}

	DeleteVideo = () => {
		axios.post(config.host + '/api/v1/video/record/delete' , {
			id: this.state.video_id,
			userid: localStorage.StudioUserID
		}).then(res => {
			toast.success('Delete video successfully !', optionToast);
			this.setState({
				modalDelete: !this.state.modalDelete
			})
			this.feedVideo()
		}).catch(err => {

		})
	}

	searchVideo = (e, data) => {
		axios.post(config.host + '/api/v1/video/record' , {
			keyword: data,
			userid: localStorage.StudioUserID
		}).then(res => {
			this.setState({
				video: res.data.result
			})
		}).catch(err => {

		})
	}

	filterStatus = (status) => {
		if (status === 'success') {
			return <span className="video-badge video-badge--success">ready</span>
		}
		if (status === 'processing' || status === 'pending') {
			return <span className="video-badge video-badge--warning">{status}</span>
		}
		return <span className="video-badge video-badge--muted">{status}</span>
	}

	renderStatus = (status) => {
		if (status === 'complete') {
			return <span className="video-badge video-badge--success">complete</span>
		}
		return <span className="video-badge video-badge--muted">{status}</span>
	}

	handleSearchKeyDown = (event) => {
		if (event.key === 'Enter') {
			this.searchVideo(event, this.state.search);
		}
	}

	chooseThumbnail = (e, data) => {
		this.setState({
			thumbnail: data.url,
			thumbnailFile: data.name
		})
	}

	updateThumbnail = () => {

		if (this.state.imgSrc) {
			var getTitle = this.state.title
			var title = getTitle.split(" ")
			var timestamp = title[0] + '-' + moment().valueOf() + '.jpg'

			const FormData = require('form-data');
			let data = new FormData();
			data.append('id', this.state.video_id);
			data.append('userid', localStorage.StudioUserID);
			data.append('filename', timestamp);
			data.append('file', this.refs.file.files[0]);

			let options = {
				method: 'POST',
				url: config.host + '/api/v1/video/record/thumbnail/upload',
				headers: {
						'Content-Type': 'multipart/form-data;'
				},
				data
		};

		axios(options).then(response => {
      console.log(response);
    }).catch(error => {
			console.log(error);
		});
		} else {
			axios.post(config.host + '/api/v1/video/record/thumbnail/selected' , {
				id: this.state.video_id,
				userid: localStorage.StudioUserID,
				thumbnail_selected: this.state.thumbnailFile
			}).then(res => {
				// this.feedVideo()
			}).catch(err => {

			})
		}
		
	}


  render() {
		const columns = [
			{
				name: "ID",
				selector: row => row.no,
				sortable: true,
				width: '70px',
			},
			{
				name: "Preview",
				width: '110px',
				cell: row => (
					<div
						className="videos-poster"
						onClick={e => this.togglePreview(e, row.id, row.status)}
						role="button"
						tabIndex={0}
						onKeyDown={e => e.key === 'Enter' && this.togglePreview(e, row.id, row.status)}
					>
						<img
							src={row.thumbnail}
							alt={row.title || 'Video thumbnail'}
							onError={(e) => { e.target.onerror = null; e.target.src = poster }}
						/>
						<div className="videos-poster__overlay">
							<i className="fas fa-play" aria-hidden="true" />
						</div>
					</div>
				)
			},
			{
				name: 'Title',
				selector: row => row.title,
				sortable: true,
				grow: 3,
				minWidth: '220px',
				wrap: true,
			},
			{
				name: "Size",
				selector: row => row.size,
				sortable: true,
				grow: 1,
				minWidth: '100px',
			},
			{
				name: "Duration",
				selector: row => row.duration,
				sortable: true,
				grow: 1,
				minWidth: '110px',
			},
			{
				name: "Multi-Bitrate",
				selector: row => row.process,
				sortable: true,
				grow: 1,
				minWidth: '130px',
				cell: row => this.filterStatus(row.process)
			},
			{
				name: "Status",
				selector: row => row.status,
				sortable: true,
				grow: 1,
				minWidth: '120px',
				cell: row => this.renderStatus(row.status)
			},
			{
				name: "Last Update",
				selector: row => row.updatedAt,
				sortable: true,
				grow: 2,
				minWidth: '160px',
				cell: row => <span>{moment(row.updatedAt).format('yyyy-MM-DD HH:mm')}</span>
			},
			{
				name: "Action",
				width: '104px',
				center: true,
				cell: row => (
					<div className="videos-actions-cell">
						<UncontrolledDropdown>
							<DropdownToggle tag="button" className="videos-actions-btn">
								<FontAwesomeIcon icon={['fas', 'ellipsis-v']} />
							</DropdownToggle>
							<DropdownMenu className="drop-table" end>
								{row.process === 'success' ? <DropdownItem onClick={e => this.toggleEmbed(e, row.id)}><FontAwesomeIcon icon={['fas', 'play']} /> Embed Player</DropdownItem> : null}
								{row.process === 'success' ? <DropdownItem onClick={e => this.toggleEdit(e, row.id)}><FontAwesomeIcon icon={['fas', 'edit']} /> Edit</DropdownItem> : null}
								<DropdownItem onClick={e => this.toggleDelete(e, row.id)}><FontAwesomeIcon icon={['fas', 'trash']} /> Delete</DropdownItem>
							</DropdownMenu>
						</UncontrolledDropdown>
					</div>
				),
			}
		];

		const videoJsOptions = {
			autoplay: true,
			// muted: true,
			controls: true,
			controlBar: {
				volumePanel: {
					inline: true
				}
			},
			fluid: true,
			responsive: true,
			sources: [
				{
					src: 'https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_fmp4/master.m3u8',
				},
			],
		};

    return (
			<div className="app-shell">
      <Navbar />
			<ToastContainer
				position="top-right"
				autoClose={50000000000}
				hideProgressBar
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
			<main className="app-main">
				<div className="videos-page">
					<div className="videos-page__header">
						<div>
							<h1 className="videos-page__title">Video Library</h1>
							<p className="videos-page__subtitle">Browse, preview, and manage recorded videos</p>
						</div>
						<div className="videos-search">
							<input
								type="text"
								className="videos-search__input"
								value={this.state.search}
								onChange={this.handleChangeSearch}
								onKeyDown={this.handleSearchKeyDown}
								placeholder="Search by title or keyword"
							/>
							<button
								type="button"
								className="videos-search__btn"
								onClick={e => this.searchVideo(e, this.state.search)}
							>
								Search
							</button>
						</div>
					</div>

					<div className="videos-card">
						<DataTable
							className="dataTables_wrapper videos-table"
							columns={columns}
							data={this.state.video}
							pagination
							striped
							persistTableHead={true}
							noHeader={true}
							noDataComponent={
								<div className="videos-empty">
									<FontAwesomeIcon icon={['fas', 'video']} style={{ fontSize: '2rem', marginBottom: '0.75rem', opacity: 0.35 }} />
									<p style={{ margin: 0 }}>No videos found</p>
								</div>
							}
						/>
					</div>
				</div>

				{/* modal preview */}
				<Modal
					isOpen={this.state.modalPreview}
					toggle={() => this.setState({ modalPreview: false })}
					centered
					backdrop="static"
					size="lg"
					className="videos-preview-modal"
					contentClassName="videos-preview-modal__content"
				>
					<div className="videos-preview-modal__header">
						<div className="videos-preview-modal__header-left">
							<span className="videos-preview-modal__badge">
								<FontAwesomeIcon icon={['fas', 'play']} />
							</span>
							<div>
								<h3 className="videos-preview-modal__title">Video Preview</h3>
								<p className="videos-preview-modal__subtitle">Watch recorded video playback</p>
							</div>
						</div>
						<button
							type="button"
							className="videos-preview-modal__close"
							onClick={() => this.setState({ modalPreview: false })}
							aria-label="Close"
						>
							<FontAwesomeIcon icon={['fas', 'times']} />
						</button>
					</div>
					<ModalBody className="videos-preview-modal__body">
						<div className="videos-preview-modal__player">
							<VideoPlayer type="vod" id={this.state.video_id} {... videoJsOptions} />
						</div>
					</ModalBody>
				</Modal>

				<Modal isOpen={this.state.modalPreviewErr} toggle={this.togglePreviewErr} centered backdrop="static" size="md">
        	<ModalHeader toggle={this.togglePreviewErr}>System Info</ModalHeader>
        	<ModalBody>
						<p>The system is currently video recording.</p>
        	</ModalBody>
				</Modal>

				{/* <Modal isOpen={this.state.modalEditErr} toggle={this.toggleEditErr} centered backdrop="static" size="md">
        	<ModalHeader toggle={this.toggleEditErr}>System Info</ModalHeader>
        	<ModalBody>
						<p>The system is currently video recording.</p>
        	</ModalBody>
				</Modal> */}

				{/* modal embed player */}
				<Modal isOpen={this.state.modalEmbed} toggle={this.toggleEmbed} centered backdrop="static">
        	<ModalHeader toggle={this.toggleEmbed}>Embed Player</ModalHeader>
        	<ModalBody>
						<div className="form-group">
							<textarea id="embed" rows="5" type="text" className="form-control" value={this.state.embed} onChange={this.handleChangeEmbed}></textarea>
							<div style={{float: 'right'}}><button type="button" className="btn btn-light" onClick={this.embedCopy}
                  style={{fontSize: 11+'px'}}>Copy</button></div>
						</div>

						
        	</ModalBody>
				</Modal>

				{/* modal edit */}
				<Modal isOpen={this.state.modalEdit} centered backdrop="static" size="lg">
        	<ModalHeader toggle={e => this.setState({modalEdit: false})}>Edit {'>'} {this.state.title}</ModalHeader>
        	<ModalBody>
						<div className="row">
							<div className="col-md-6">
								<div className="form-group">
									<div className="">
										<div className="">
											<div className="form-group">
												<label className="form-label text-left">Title</label>
												<input type="text" className="form-control" id="title" placeholder="title" value={this.state.title} onChange={this.handleChangeTitle}></input>
											</div>
											<div className="form-group">
												<label className="form-label text-left">Description</label>
												<textarea id="desc" rows="5" type="text" className="form-control" value={this.state.desc} onChange={this.handleChangeDesc}></textarea>
											</div>
											<div className="form-group">
												<div className="form-label">Public</div>
													<div className="custom-controls-stacked">
														<label className="custom-control custom-radio custom-control-inline">
															<input type="radio" className="custom-control-input" value="true" checked={this.state.enable === "true"} onChange={this.handleChangeEnable} />
															<span className="custom-control-label">Enable</span>
														</label>
														<label className="custom-control custom-radio custom-control-inline">
															<input type="radio" className="custom-control-input" value="false" checked={this.state.enable === "false"} onChange={this.handleChangeEnable} />
															<span className="custom-control-label">Disable</span>
														</label>
													</div>
											</div>
										</div>
									</div>
							
									{/* <textarea rows="5" type="text" className="form-control"></textarea>
									<div style={{float: 'right'}}><button type="button" className="btn btn-light"
                  		style={{fontSize: 11+'px'}}>Copy</button></div> */}
								</div>
							</div>

							<div className="col-md-6">
								<div className="form-group">
									<label className="form-label text-left">Thumbnails</label>
									{!this.state.imgSrc ? <img src={this.state.thumbnail} alt="Selected thumbnail" style={{width: '230px'}} /> : <img src={this.state.imgSrc} alt="Uploaded thumbnail preview" style={{width: '230px'}} />}
								</div>
								<div className="form-group">
									<form>
										<input ref="file" 
        							type="file" 
        							name="user[image]"
        							onChange={this.handleChangeThumbnails} />
									</form>
								</div>

								<div className="row">
									{this.state.thumbnails.map((item, index) => 
										<div className="col-md-4" style={{marginBottom:'10px'}} onClick={e => this.chooseThumbnail(e, item)}>
											<img src={item.url} alt={`Thumbnail ${index + 1}`} style={{width: '120px'}} className={item.url === this.state.thumbnail ? 'btn-thumbnail active-thumbnail ' : 'btn-thumbnail'}/>
										</div>
									)}
									<div className="col-md-4">
										<img src={this.state.imgSrc} alt="Uploaded thumbnail" style={{width: '120px'}} className="btn-thumbnail" />
									</div>
									
								</div>
							</div>
						
						</div>
						

						
        	</ModalBody>
					<ModalFooter>
						<div>
							<button className="btn btn-primary" onClick={this.UpdateVideo} style={{margin: 10+'px'}}>Update</button>
							<button className="btn btn-light" onClick={e => this.setState({modalEdit: false})} style={{margin: 10+'px'}}>Close</button>
						</div>
					</ModalFooter>
				</Modal>

				{/* modal delete */}
				<Modal
					isOpen={this.state.modalDelete}
					toggle={this.toggleDelete}
					centered
					backdrop="static"
					className="videos-delete-modal"
					contentClassName="videos-delete-modal__content"
				>
					<ModalBody className="videos-delete-modal__body">
						<button
							type="button"
							className="videos-delete-modal__close"
							onClick={this.toggleDelete}
							aria-label="Close"
						>
							<FontAwesomeIcon icon={['fas', 'times']} />
						</button>
						<div className="videos-delete-modal__icon">
							<FontAwesomeIcon icon={['fas', 'trash-alt']} />
						</div>
						<h3 className="videos-delete-modal__title">Delete video?</h3>
						<p className="videos-delete-modal__text">
							Are you sure you want to delete
							{this.state.title ? <strong> {this.state.title}</strong> : ' this video'}?
							This action cannot be undone.
						</p>
						<div className="videos-delete-modal__actions">
							<button
								type="button"
								className="videos-delete-modal__btn videos-delete-modal__btn--cancel"
								onClick={this.toggleDelete}
							>
								Cancel
							</button>
							<button
								type="button"
								className="videos-delete-modal__btn videos-delete-modal__btn--delete"
								onClick={this.DeleteVideo}
							>
								Delete
							</button>
						</div>
					</ModalBody>
				</Modal>
			</main>
			<Footer />
			</div>
    );
  }
}

export default Video

